module.exports = __webpack_public_path__ + "assets/Social-round-facebook.bc648154.svg";